import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54bf79da"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "options"
}
const _hoisted_2 = { class: "filters" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.allTodosCount > 0)
    ? (_openBlock(), _createElementBlock("footer", _hoisted_1, [
        _createElementVNode("span", null, _toDisplayString($setup.activeTodosCount) + " Осталось", 1),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", {
            class: _normalizeClass(["option", $setup.status === 'all' && 'active']),
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.handleSetStatus('all')))
          }, "Все", 2),
          ($setup.activeTodosCount > 0 && $setup.doneTodosCount > 0)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass(["option", $setup.status === 'active' && 'active']),
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.handleSetStatus('active')))
              }, "Активные", 2))
            : _createCommentVNode("", true),
          ($setup.doneTodosCount > 0 && $setup.activeTodosCount > 0)
            ? (_openBlock(), _createElementBlock("span", {
                key: 1,
                class: _normalizeClass(["option", $setup.status === 'completed' && 'active']),
                onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.handleSetStatus('completed')))
              }, "Завершенные", 2))
            : _createCommentVNode("", true)
        ]),
        ($setup.doneTodosCount > 0)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "option",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.handleClearCompleted && $setup.handleClearCompleted(...args)))
            }, "Убрать выполненные"))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}